import { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { CATEGORIES } from '@/mocks/comics';

const NAV_ITEMS = [
  { label: '首页', to: '/' },
  { label: '发现好漫', to: '/category/reXue' },
  { label: '关于我们', to: '/about' },
];

export default function Navbar() {
  const location = useLocation();
  const isHome = location.pathname === '/';
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const [catOpen, setCatOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    setOpen(false);
    setCatOpen(false);
  }, [location.pathname]);

  const solid = !isHome || scrolled || open;
  const scrollTop = () => window.scrollTo({ top: 0, behavior: 'smooth' });

  return (
    <header className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${solid ? 'bg-background-50/95 backdrop-blur shadow-sm border-b border-background-200/70' : 'bg-transparent'}`}>
      <nav className="mx-auto flex h-16 md:h-[72px] max-w-7xl items-center justify-between px-4 md:px-6" aria-label="主导航">
        <Link to="/" onClick={scrollTop} className="flex items-center gap-2 whitespace-nowrap">
          <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
            <i className="ri-book-2-fill text-lg"></i>
          </span>
          <span className={`font-heading text-2xl leading-none ${solid ? 'text-foreground-950' : 'text-background-50'}`}>漫画岛</span>
        </Link>

        <div className="hidden items-center gap-1 md:flex">
          {NAV_ITEMS.map((item) => (
            <Link
              key={item.to}
              to={item.to}
              onClick={scrollTop}
              className={`rounded-full px-4 py-2 text-sm font-medium whitespace-nowrap transition-colors ${
                location.pathname === item.to
                  ? 'bg-primary-500 text-background-50'
                  : solid
                    ? 'text-foreground-700 hover:bg-background-200/60'
                    : 'text-background-50/90 hover:bg-background-50/15'
              }`}
            >
              {item.label}
            </Link>
          ))}

          <div className="relative" onMouseEnter={() => setCatOpen(true)} onMouseLeave={() => setCatOpen(false)}>
            <button
              type="button"
              onClick={() => setCatOpen((v) => !v)}
              className={`flex items-center gap-1 rounded-full px-4 py-2 text-sm font-medium whitespace-nowrap transition-colors ${
                solid ? 'text-foreground-700 hover:bg-background-200/60' : 'text-background-50/90 hover:bg-background-50/15'
              }`}
              aria-haspopup="menu"
              aria-expanded={catOpen}
            >
              分类
              <i className={`ri-arrow-down-s-line text-base transition-transform ${catOpen ? 'rotate-180' : ''}`}></i>
            </button>
            {catOpen && (
              <div className="absolute left-0 top-full mt-2 w-56 rounded-xl border border-background-200/80 bg-background-50 p-2 shadow-sm" role="menu">
                {CATEGORIES.map((c) => (
                  <Link
                    key={c.slug}
                    to={`/category/${c.slug}`}
                    onClick={scrollTop}
                    className="flex items-center gap-3 rounded-lg px-3 py-2 text-sm text-foreground-700 hover:bg-background-100"
                    role="menuitem"
                  >
                    <span className="flex h-8 w-8 items-center justify-center rounded-md bg-secondary-100 text-secondary-700">
                      <i className={`${c.icon}`}></i>
                    </span>
                    <span className="font-medium">{c.name}</span>
                    <span className="ml-auto text-xs text-foreground-400">{c.count}</span>
                  </Link>
                ))}
              </div>
            )}
          </div>
        </div>

        <div className="hidden items-center gap-3 md:flex">
          <Link
            to="/category/reXue"
            onClick={scrollTop}
            className={`inline-flex items-center gap-2 rounded-full px-5 py-2.5 text-sm font-bold whitespace-nowrap transition-colors ${
              solid ? 'bg-primary-500 text-background-50 hover:bg-primary-600' : 'bg-background-50 text-foreground-950 hover:bg-background-100'
            }`}
          >
            <i className="ri-compass-3-line text-base"></i>
            开始发现
          </Link>
        </div>

        <button
          type="button"
          onClick={() => setOpen((v) => !v)}
          className={`flex h-10 w-10 items-center justify-center rounded-lg text-xl md:hidden ${solid ? 'text-foreground-950' : 'text-background-50'}`}
          aria-label="打开菜单"
        >
          <i className={open ? 'ri-close-line' : 'ri-menu-line'}></i>
        </button>
      </nav>

      {open && (
        <div className="border-t border-background-200/70 bg-background-50 px-4 pb-4 pt-2 md:hidden">
          {[...NAV_ITEMS, { label: '分类浏览', to: '/category/reXue' }].map((item) => (
            <Link
              key={item.label}
              to={item.to}
              onClick={scrollTop}
              className="block rounded-lg px-3 py-3 text-base font-medium text-foreground-800 hover:bg-background-100"
            >
              {item.label}
            </Link>
          ))}
          <div className="mt-2 grid grid-cols-2 gap-2">
            {CATEGORIES.slice(0, 6).map((c) => (
              <Link
                key={c.slug}
                to={`/category/${c.slug}`}
                onClick={scrollTop}
                className="flex items-center gap-2 rounded-lg bg-background-100 px-3 py-2.5 text-sm text-foreground-700"
              >
                <i className={`${c.icon} text-secondary-600`}></i>
                {c.name}
              </Link>
            ))}
          </div>
        </div>
      )}
    </header>
  );
}